export const tr = {
    cancel: 'İptal',
    description: 'Proje detayları',
    save: 'Kaydet'
};
